<template>
    <div>
        <div v-if="field.$error" class="errorTooltip">
            <div v-if="field.minLength !== undefined && !field.minLength">El campo debe tener una longitud mínima de
                {{field.$params.minLength.min}}.
            </div>
            <div v-if="field.maxLength !== undefined && !field.maxLength">El campo debe tener una longitud máxima de
                {{field.$params.maxLength.max}}.
            </div>
            <div v-if="field.required !== undefined && !field.required">Requerido</div>
            <div v-if="field.numeric !== undefined && !field.numeric">Solo números están permitidos</div>
            <div v-if="field.decimal !== undefined && !field.decimal">Solo números están permitidos</div>
            <div v-if="field.email !== undefined && !field.email">Formato de correo electrónico incorrecto.</div>
            <div v-if="field.alpha !== undefined && !field.alpha">Solo se permiten letras</div>
            <div v-if="field.plate !== undefined && !field.plate">Formato de placa incorrecto.</div>
            <div v-if="field.alphaNum !== undefined && !field.alphaNum">Solo letras y números están permitidos.</div>
            <div v-if="field.exactLength !== undefined && !field.exactLength">El campo debe tener una longitud de
                {{field.$params.exactLength.value}}
            </div>
            <div v-if="field.lat!== undefined && !field.lat">Formato de latitud incorrecto</div>
            <div v-if="field.lon!== undefined && !field.lon">Formato de longitud incorrecto</div>
            <div v-if="field.minValue !== undefined && !field.minValue">El valor debe ser como mínimo
                {{field.$params.minValue.min}}
            </div>
            <div v-if="field.maxValue !== undefined && !field.maxValue">El valor debe ser como máximo
                {{field.$params.maxValue.max}}
            </div>
            <div v-if="field.sameAsPassword !== undefined && !field.sameAsPassword">Contraseñas deben coincidir.</div>
            <div v-if="field.dateGreaterThan !== undefined && !field.dateGreaterThan">Fecha debe ser mayor o igual a la
                fecha de inicio
            </div>
            <div v-if="field.checkoutDateGreaterThan !== undefined && !field.checkinDateGreaterThan">La fecha de
                check-out debe ser mayor o igual a la de check-in
            </div>
            <div v-if="field.checkinDateGreaterThan !== undefined && !field.checkinDateGreaterThan">La fecha de
                check-in debe ser mayor o igual a la fecha actual
            </div>
            <div v-if="field.greaterThan!== undefined && !field.greaterThan">No puede ser mayor a valor inicial</div>
            <div v-if="field.date !== undefined && !field.date">Fecha no v&aacute;lida
            </div>
            <div v-if="field.integer !== undefined && !field.integer">Debe ingresar un número entero positivo</div>
            <div v-if="field.hour !== undefined && !field.hour">Ingrese un formato de horas válido</div>
            <div v-if="field.hourGreaterThan !== undefined && !field.hourGreaterThan">Hora de fin debe ser mayor a hora
                de inicio
            </div>
        </div>

        <input v-if="tipo==='text' || tipo==='password'"
               :type="tipo" class="form-control"
               :maxlength="longitud"
               ref="input"
               v-on:keypress.enter="onPressEnter"
               v-model.trim="field.$model"
               v-custom-validations="field.$error"
               :disabled="disabled"
               autocomplete="off"
               :placeholder="placeholder"
        />

        <!--<select v-if="tipo==='select'"
                :disabled="disabled"
                ref="input"
                class="form-control" v-model="field.$model"
                v-customValidations="field.$error">
            <option v-if="selectLabel" value="" selected>Select an option</option>
            <option v-for="i in items" :value="i.key" :key="i.key">
                {{i.value}}
            </option>
        </select>-->
        <div v-custom-validations="field.$error" v-if="tipo==='select'">
            <multiselect
                :disabled="disabled"
                v-model="field.$model" :options="items"
                :show-labels="false"
                :loading="loading"
                :placeholder="placeholder ? placeholder : 'Seleccione una opción'" label="value" track-by="key">
                <template slot="noResult">No se pudo encontrar un item relacionado.</template>
                <template slot="noOptions">Sin elementos</template>
            </multiselect>
        </div>
        <div v-custom-validations="field.$error" v-if="tipo==='multiselect'">
            <multiselect
                :disabled="disabled"
                v-model="field.$model" :options="items"
                :show-labels="false"
                :loading="loading"
                :multiple="true"
                :taggable="true"
                :placeholder="placeholder ? placeholder : 'Seleccione una opción'" label="value" track-by="key">
                <template slot="noResult">No se pudo encontrar un item relacionado.</template>
                <template slot="noOptions">Sin elementos</template>
            </multiselect>
        </div>
        <input v-if="tipo==='mask'"
               class="form-control"
               :maxlength="longitud"
               ref="input"
               type="text"
               v-on:keypress.enter="onPressEnter"
               v-model.trim="field.$model"
               v-custom-validations="field.$error"
               :disabled="disabled"
               autocomplete="off"
               v-mask="mask"
               :placeholder="placeholder"/>
        <date-picker v-if="tipo==='date'"
                     :placeholder="placeholder"
                     placeholder="dd/mm/yyyy"
                     :init="init"
                     v-model="field.$model"
                     :future="future"
                     :validacion="field.$error"/>
        <vue-tel-input v-if="tipo==='phone' && defaultCountry" class="form-control"
                       :onlyCountries="onlyCountries"
                       :enabledCountryCode="true"
                       :disabledFetchingCountry="true"
                       v-on:country-changed="countryChanged"
                       style="padding: 0"
                       placeholder=""
                       :defaultCountry="defaultCountry"
                       v-custom-validations="field.$error"
                       v-model="field.$model"></vue-tel-input>
    </div>
</template>

<script>

    import DatePicker from '../common/DatePicker.vue'
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            DatePicker,
            Multiselect
        },
        props: {
            tipo: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            onlyCountries: {
                required: false,

            },
            field: Object,
            focus: Boolean,
            loading: Boolean,
            countryChanged: {
                type: Function,
                default: (e) => {
                }
            },
            onPressEnter: {
                type: Function,
                default: () => {
                }
            },
            longitud: {
                type: Number
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            defaultCountry: {
                type: String,
                default: '',
                required: false,
            },
            init: {
                type: Boolean,
                required: false,
                default: true
            },
            future: {
                type: Boolean,
                required: false,
                default: false
            },
            mask: {
                type: String,
                required: false,
                default: ''
            },
            selectLabel: {
                type: Boolean,
                default: true
            },
            items: Array
        },
        mounted() {
            if (this.focus) {
                this.$refs.input.focus();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/CustomInput.vue